export default __webpack_public_path__ + "static/media/element_73.2d7d6a04.webp";